import { CartAddEvent } from '@theme/events';

// Delegate to the document so controls still work after the cart is re-rendered.
document.addEventListener('click', async (event) => {
  if (!(event.target instanceof Element)) return;

  const scrollButton = event.target.closest('[data-upsell-scroll]');
  if (scrollButton) {
    const carousel = scrollButton.closest('.fitb-cart-upsell')?.querySelector('[data-fitb-carousel]');
    carousel?.scrollBy({
      left: (carousel.clientWidth || 280) * 0.75 * Number(scrollButton.dataset.upsellScroll),
      behavior: 'smooth',
    });
    return;
  }

  const button = event.target.closest('[data-upsell-add-btn]');
  if (!(button instanceof HTMLButtonElement)) return;
  event.preventDefault();
  const variantId = button.dataset.variantId;
  if (!variantId || button.disabled) return;

  button.disabled = true;
  button.classList.add('is-loading');

  try {
    const sections = [...new Set(
      Array.from(document.querySelectorAll('cart-items-component'), (element) => element.dataset.sectionId)
        .filter(Boolean)
    )];
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sections.slice(0, 5),
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) {
      throw new Error(data.description || data.message || 'Could not add product to cart');
    }

    // Use the same rendering and badge update path as the product form.
    document.dispatchEvent(new CartAddEvent(data, 'cart-drawer-upsell', {
      source: 'cart-drawer-upsell',
      itemCount: 1,
      variantId,
      sections: data.sections,
    }));
  } catch (error) {
    console.error('Add to cart failed:', error);
    alert(error.message || 'Error adding product to cart.');
  } finally {
    button.classList.remove('is-loading');
    button.disabled = false;
  }
});
